<mat-card
  appClickOutside
  [className]="classNames.MAT_CALENDAR_BODY_CELL_CONTENT"
  (clickOutside)="closeCalendar()"
  *ngIf="!closeDatepicker"
  [ngClass]="{
    'inline-calendar-card': true,
    'current-date-not-highlighted': !isCurrentDateHighlighted
  }"
>
  <mat-calendar
    [minDate]="minDate"
    [maxDate]="maxDate"
    [(selected)]="selected"
    [dateFilter]="dateFilter"
    [startAt]="selected"
    (selectedChange)="dateSelected()"
    [dateClass]="getSpecificClassForParticularDate()"
    (viewChanged)="getCalendarView($event)"
  >
  </mat-calendar>
</mat-card>
